<template>
  <div class="about m-4" style="max-width: 40em;">

    <h1 class="text-4xl font-bold xl:mt-40">Ako to funguje</h1>


    <h2 class="mt-10">tl;dr</h2>

    <!-- <div class="text-sm text-gray-500 mb-4">[príliš-dlhé-nečítam]</div> -->

    <summary class="text-xl list-none italic pl-4 border-l-4 mb-10 text-gray-600 ">holubnik.sk umožňuje rýchle odosielanie súborov priamo medzi dvoma webovými prehliadačmi, bez nahrávania na server.</summary>


    <p>holubnik.sk vytvára šifrované spojenie (P2P) medzi dvoma zariadeniami, pričom využíva najkratšiu cestu medzi nimi. Vďaka tomu sa súbory nemusia nahrávať na žiadny server, ale môžu sa odosielať priamo do druhého prehliadača, ktorý ich okamžite prijíma ako bežné sťahovanie.</p>

    <p>Možnosti použitia:

        <ul class="list-disc py-2">
            <li>potrebujem rýchlo odoslať veľké súbory kamošovi, kolegovi alebo klientovi</li>
            <li>potrebujem si poslať súbory medzi počítačom a mobilom</li>
            <li>potrebujem (super)rýchlo odoslať súbory v rámci lokálnej siete - bez nastavovania zdieľania, bez USB kľúča</li>
        </ul>
    </p>

    <h2 class="mt-10">Technológie</h2>

    <h3>WebRTC</h3>

    <p>
        Na vytvorenie spojenia sa používa <a href="https://en.wikipedia.org/wiki/WebRTC">WebRTC</a>, čo je technológia webových prehliadačov, ktorá umožňuje priamy prenos dát medzi nimi v reálnom čase bez nutnosti inštalovania pluginov, či iného softvéru. WebRTC sa bežne používa pri internetových volaniach vo webových aplikáciách ako Zoom, či WhatsApp.
    </p>
    <img src="@/assets/img/holubnik-WebRTC.png" alt="" class="">
    <p>
        Hlavný problém, ktorý WebRTC rieši je ten, že bežní užívatelia internetu väčšinou nepoužívajú verejnú IP a sú skrytí za <a href="https://sk.wikipedia.org/wiki/Network_address_translation">NAT</a>, teda sa nemôžu kontaktovať napriamo bez použitia sprostredkovateľa. Bežné riešenie tohoto problému pri zdieľaní súborov je preto ich nahratie na server s verejnou IP, napr. Google Drive, Dropbox, či Wetransfer a ich následné stiahnutie druhou stranou. Vďaka WebRTC sa obe strany vedia dohodnúť, na akej adrese budú vzájomne komunikovať napriamo, pokiaľ to umožňuje nastavenie siete. Výmena súborov je tak rýchlejšia a bezpečnejšia.
    </p>

    <h3>Signalizačný server</h3>

    <p>
        Server holubnik.sk slúži ako sprostredkovateľ pri vytváraní priameho WebRTC spojenia. Na tento účel si server pamätá čísla čakajúcich pripojení, ktoré korešpondujú s číslom v odkazoch na zdieľanie, ktoré generuje webová aplikácia. Keď druhá strana otvorí tento odkaz v prehliadači, dôjde ku vytvoreniu priameho WebRTC spojenia pomocou výmeny a výberu kandidátov. Úloha servera tu končí, pretože všetko, čo sa deje ďalej, prebieha priamo medzi webovými prehliadačmi. Signalizačný server vychádza z WebRTC implementácie <a href="https://github.com/warner/magic-wormhole">MagicWormhole</a> a <a href="https://github.com/saljam/webwormhole">WebWormhole</a>.
    </p>

    <h3>End-to-end šifrovanie</h3>

    <p>Po nadviazaní spojenia medzi prehliadačmi dôjde cez toto prepojenie ku výmene šifrovacích kľúčov. Táto výmena je naviac zabezpečená heslom (<a href="https://en.wikipedia.org/wiki/Password-authenticated_key_agreement">PAKE</a>), ktoré tvorí druhú časť zdieľaného odkazu - dve náhodne vybrané slová, ktoré sú známe len týmto dvom stranám. Po výmene kľúčov je všetko pripravené na bezbečné odosielanie súborov. Pri pridaní súboru na odosielanie sa súbor po častiach zašifruje a odošle druhej strane, ktorá ako jediná pozná kľúč na jej rozšifrovanie - teda celá výmena súborov prebieha cez tzv. <a href="https://en.wikipedia.org/wiki/End-to-end_encryption">End-to-end šifrovanie</a>.</p>

    <h3>STUN a TURN server</h3>

    <p>Pomocou WebRTC sa spojenie môže uskutočniť troma spôsobmi, ktoré závisia od nastavenia NAT a použitých sieťových zariadení:</p>
    <ul class="list-disc mb-4">
        <li>priame P2P spojenie</li>
        <li>priame spojenie s použitím STUN servera na získanie verejnej IP adresy</li>
        <li>nepriame spojenie cez TURN server</li>
    </ul>
    <p>Webový prehliadač automaticky zabezpečí, aby bol vybraný najrýchlejši možný kandidát pripojenia.</p>

    <h3>Ukončenie spojenia</h3>

    <p>V prípade, že ktorákoľvek strana opustí okno prehliadača s otvoreným spojením, tunel sa okamžite uzavrie a odkaz je ďalej nepoužiteľný. Vďaka tejto jednorázovosti odkazov, si môžu byť obe strany isté, že sa k druhej strane tunela nemôže pripojiť nikto iný.</p>

  </div>
</template>

<script>

    export default {

        metaInfo: {
            title: 'Technológie',
        }
    }

</script>

<style scoped>

    h1, h2, h3, p, img {
        @apply mb-4
    }

    h1, h2, h3 {
        @apply font-bold
    }

    h2 { @apply text-2xl }
    h3 { @apply text-lg }


    a { @apply text-gray-500  }

</style>
